// https://snazzymaps.com/
let styles = [{
    "featureType": "administrative",
    "elementType": "all",
    "stylers": [{"saturation": "-100"}]
}, {
    "featureType": "administrative.province",
    "elementType": "all",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [{"saturation": -100}, {"lightness": 65}, {"visibility": "on"}]
}, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{"saturation": -100}, {"lightness": "50"}, {"visibility": "simplified"}]
}, {"featureType": "road", "elementType": "all", "stylers": [{"saturation": "-100"}]}, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{"visibility": "simplified"}]
}, {
    "featureType": "road.arterial",
    "elementType": "all",
    "stylers": [{"lightness": "30"}]
}, {"featureType": "road.local", "elementType": "all", "stylers": [{"lightness": "40"}]}, {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [{"saturation": -100}, {"visibility": "simplified"}]
}, {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [{"hue": "#ffff00"}, {"lightness": -25}, {"saturation": -97}]
}, {"featureType": "water", "elementType": "labels", "stylers": [{"lightness": -25}, {"saturation": -100}]}];

let primaryColor = '#5AD060';

function getIcon() {
    return {
        path: "M30.3603972,11.2342799 C30.1997291,10.6321156 29.8734606,9.99049252 29.6320911,9.4287313 C26.7438429,2.48757481 20.4330806,0 15.3374561,0 C8.51603985,0 1.00304759,4.57405652 1.13686838e-13,14.0022631 L1.13686838e-13,15.9284965 C1.13686838e-13,16.008883 0.0277050182,16.7309975 0.0670587372,17.0922122 C0.629344674,21.5854624 4.1748524,26.3608001 6.8227805,30.8540503 C9.67156998,35.668112 12.6276115,40.4037812 15.5562628,45.1374564 C17.3621262,42.0483468 19.1614832,38.9186243 20.9262089,35.9094815 C21.4071638,35.0263841 21.9654619,34.1438113 22.4469415,33.3009071 C22.767858,32.7396706 23.3809365,32.1784341 23.66103,31.6562365 C26.5097145,26.4406619 31.095,21.1847891 31.095,16.0087781 L31.095,13.8824179 C31.0951049,13.3212864 30.3995411,11.3552795 30.3603972,11.2342799 L30.3603972,11.2342799 Z M15.4623386,20.9039609 C13.4571879,20.9039609 11.2624047,19.9013331 10.1790755,17.1324054 C10.0176728,16.6916438 10.0306858,15.8083364 10.0306858,15.7274252 L10.0306858,14.4836378 C10.0306858,10.9537666 13.027865,9.34855466 15.635285,9.34855466 C18.8452892,9.34855466 21.3279317,11.9167259 21.3279317,15.12673 C21.3279317,18.3366292 18.6723427,20.9039609 15.4623386,20.9039609 L15.4623386,20.9039609 Z",
        size: new google.maps.Size(32, 46),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(16, 46),
        fillColor: primaryColor,
        fillOpacity: 1,
        strokeColor: 'black',
        strokeWeight: 0
    };
}

function initMap() {
    let bounds = new google.maps.LatLngBounds();
    let infowindow = new google.maps.InfoWindow();

    let map = new google.maps.Map(document.getElementById('ec-map'), {
        scrollwheel: false,
        styles: styles
    });

    return [bounds, infowindow, map];
}

export {
    initMap,
    getIcon,
    primaryColor
};